export default __webpack_public_path__ + "static/media/green-divider-bottom.a5f58ba9.svg";